import * as React from "react";
import { semanticColors } from "~/common/colors/colors";
import { messageBoardResx } from "~/resxDist/messageBoardResx";
import { Text } from "~/sharedComponents/layout";
import { AiSuggestionBlockName } from "../types";

/**
 *  Renders preview of AI completion in editor.
 */
export const AiSuggestionBlock: React.FC = ({ children }) => {
    return (
        <div style={{ userSelect: "none" }} contentEditable={false} className={AiSuggestionBlockName}>
            <Text tag="div" small={true} color={semanticColors.neutral.text.quaternary}>
                {messageBoardResx.GeneratedByAi}
            </Text>
            <i>{children}</i>
        </div>
    );
};
